const state = {
	count: {
		common: 0,
		personal: 0
	},
	messageList: []
}

const mutations = {
	SET_COUNT: (state, messageList) => {
		state.count.common = 0;
		state.count.personal = 0;
		for(let message of messageList){
			if(message.sendType == "common"){
				state.count.common ++;
			}else if(message.sendType == "personal"){
				state.count.personal ++;
			}
		}
	},
	UPDATE_COUNT: (state, data) => {
		let {message, val} = data;
		if(message.sendType == 'common'){
			state.count["common"] += val;
		}
		if(message.sendType == 'personal'){
			state.count["personal"] += val;
		}
	},
	SET_MESSAGE_LIST: (state, messageList) => {
		state.messageList = messageList;
	},
	ADD_MESSAGE: (state, data) => {
		state.messageList.unshift(data);
	},
	REMOVE_MESSAGE: (state, index) => {
		state.messageList.splice(index,1);
	},
};

const actions = {
	setMessageList({ commit, state, dispatch, rootState }, messageList) {
		commit("SET_MESSAGE_LIST", messageList)
		commit("SET_COUNT", messageList);
	},
	addMessage({ commit, state}, data){
		console.log(data);
		if(!state.messageList.some(message=>message.msgid == data.msgid)){
			commit("UPDATE_COUNT", {
				message: data,
				val: 1
			});
			commit("ADD_MESSAGE", data);
		}
	},
	removeMessage({ commit, state }, confirmIdArr){
		for(let i = 0; i < state.messageList.length; i++){
			for(let id of confirmIdArr){
				if(state.messageList[i].msgid == id){
					commit("UPDATE_COUNT", {
						message: state.messageList[i],
						val: -1
					});
					commit("REMOVE_MESSAGE", i)
					i --
					break;
				}
			}
		}
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
}